// TODO contact support to add missing fields

/*
  This method ensures the conversion of Fast Simon product data into a format compatible with Shopify, facilitating seamless integration and display on Shopify-powered e-commerce platforms.
*/
export const ConvertToShopifyProduct = (product) => {
  const {
    vra, // variants
    v_c, // variants count
    att, // attributes
    id, // id
    iso, // product sold out
    p_c, // price compare
    p_max_c, // price compare max
    p_min_c, // price compare min
    d, // description
    t, // image
    t2, // fall back image
    u, // url
    l, // title
    p, // price
    p_max, // product variant max price range
    p_min, // product variant min price range
    b, // product/variant on sale
    s // idk tbh, product search query id? needed for autocomplete events reporting
  } = product;

  // Product attributes
  const productAttributes = Object.fromEntries(att || []);
  const categories = (productAttributes["Categories"] || []).flat();
  const tags = productAttributes["Tag"] || [];
  const vendor = (productAttributes["Vendor"] || [])[0] || "";

  // Product options name
  const productAttributesEntris = Object.entries(productAttributes);
  const optionsName = productAttributesEntris
    .filter(([key]) => key.startsWith("Option"))
    .map(([, value]) => value)
    .flat();

  // Product options with values
  const optionsWithValues = productAttributesEntris
    .filter(([key]) => key.startsWith("Option"))
    .map(([name, values]) => {
      const attributeName = values[0];
      const position = Number(name.replace(/\D/g, ''));
      const optionValues = vra
        .map(([, attributes]) => attributes.find(([attrName]) => attrName === attributeName))
        .filter(Boolean)
        .flatMap(([, values]) => values);
      return ({
        name: attributeName,
        position: position,
        values: [...new Set(optionValues)]
      })
    });

  // Variant objects
  const shopifyVariants = vra ? vra.map(([variantId, properties]) => {
    const variantProperties = Object.fromEntries(properties.map(([name, values]) => [name, Array.isArray(values) ? values[0] : values]));
    const variantImage = variantProperties["imgs"];
    const variantPrice = variantProperties["Price"];
    const variantCompareAtPrice = variantProperties["Compare at price"];

    let variant = {
      id: parseInt(variantId),
      title: variantProperties["Title"] || "",
      available: variantProperties["Sellable"],
      compare_at_price: variantCompareAtPrice ? variantCompareAtPrice.split(":")[1] * 100 : null,
      featured_image: variantImage || null,
      featured_media: variantImage || null,
      price: variantPrice ? variantPrice.split(":")[1] * 100 : null,
      product: null, // Will be updated after ShopifyProduct creation
      sku: variantProperties["Product-sku"] || "",
      url: `${u}?variant=${variantId}`,
      weight: parseFloat(variantProperties["Weight"]) || 0,
      option_color: variantProperties["Color"] || "",
    };

    // Update variant with options value
    optionsWithValues.forEach(option => {
      variant[`option${option.position}`] = variantProperties[option.name] || null;
    });

    return variant;
  }) : [];

  // Product first available variant
  const firstAvailableIndex = shopifyVariants.findIndex(variant => variant.available);
  const firstAvailableVariant = firstAvailableIndex !== -1 ? shopifyVariants[firstAvailableIndex] : null;

  // Product object
  const shopifyProduct = {
    id: parseInt(id),
    available: !iso,
    collections: categories,
    compare_at_price: p_c ? p_c * 100 : null,
    compare_at_price_max: p_max_c ? p_max_c * 100 : null,
    compare_at_price_min: p_min_c ? p_min_c * 100 : null,
    compare_at_price_varies: p_max_c !== p_min_c,
    description: d,
    featured_image: t || t2 || null,
    first_available_variant: firstAvailableVariant,
    handle: u.split("/products/")[1].split("?")[0],
    has_only_default_variant: (vra && vra.length === 1) || (v_c === 1),
    images: [
      t || null,
      t2 || null,
      ...(productAttributes?.["Product images"] || [])
    ],
    options: optionsName,
    options_with_values: optionsWithValues,
    price: p * 100,
    price_max: p_max ? p_max * 100 : null,
    price_min: p_min ? p_min * 100 : null,
    price_varies: p_max !== p_min,
    selected_or_first_available_variant: firstAvailableVariant || shopifyVariants[0],
    selected_variant: firstAvailableVariant || shopifyVariants[0],
    tags: tags,
    title: l,
    url: u,
    vendor: vendor,
    variants: shopifyVariants,
    variants_count: v_c,
    on_sale: b,
    s: s
  };

  // Update product reference in variants
  shopifyProduct.variants.forEach(variant => {
    variant.product = shopifyProduct;
  });

  return shopifyProduct;
};
